module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "part-number-with-part-title",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('span', {
    staticClass: "bold CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("ACT ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "part-title-with-part-number",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "bold CharOverride-7"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Diagnosis ")])]), _vm._v(" "), _c('p', {
    staticClass: "extract-flush-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The play’s the thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "extract-right-space-after"
  }, [_vm._v("—William Shakespeare, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hamlet")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d0cd5d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HowMidsummerNight-4-1.vue
// module id = 78
// module chunks = 0